import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {HotspotCreatorService} from "../../../../../service/http/hotspot-creator.service";
import {HotspotDotLink} from "../../../../../model/HotspotDotLink";
import {catchError} from "rxjs/operators";
import {of as observableOf} from "rxjs";
import {MessageDialogComponent} from "../../../../../dialog/message-dialog/message-dialog.component";

@Component({
  selector: 'app-change-link-by-toc-tree',
  templateUrl: './change-link-by-toc-tree.component.html',
  styleUrls: ['./change-link-by-toc-tree.component.css']
})
export class ChangeLinkByTocTreeComponent implements OnInit {

  currentPackageIdGlobal: any;
  isLoadingResults: boolean = true;
  treeData: HotspotDotLink[];

  treeControl = new NestedTreeControl<HotspotDotLink>(node => node.children);
  dataSource = new MatTreeNestedDataSource<HotspotDotLink>();

  dotLabelFormControl = new FormControl('', [
    Validators.required
  ]);

  dotLinkRefFormControl = new FormControl('', [
    Validators.required
  ]);

  public dotFormGroup = new FormGroup({
    dotLabel: this.dotLabelFormControl,
    dotLinkRef: this.dotLinkRefFormControl});

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ChangeLinkByTocTreeComponent>,
              private hotspotCreatorService: HotspotCreatorService,
              public dialog: MatDialog) {

    let currentPackageId = sessionStorage.getItem('currentPackageId');
    if(currentPackageId !== null) {
      this.currentPackageIdGlobal = currentPackageId;
    }

    this.hotspotCreatorService.getHotspotDotLinks(this.currentPackageIdGlobal)
      .pipe(
        catchError((error) => {
          this.isLoadingResults = true;
          if(error.status == 404) {
            this.isLoadingResults = false;

            let errorDialog = this.dialog.open(MessageDialogComponent, {
              data: {   type: '', title: 'Could not load data!', message: 'Invalid XML file provided', secondMsg: error.error.file}
            });

            errorDialog.afterClosed().subscribe(result => {
              this.dialogRef.close();
            });

            return observableOf([]);
          }

        }))
      .subscribe(data => {
        this.treeData = data;
        this.dataSource.data = data;
        this.treeControl.dataNodes = data;
        this.isLoadingResults = false;
      });
  }

  ngOnInit() {}

  selectedLink: HotspotDotLink = new HotspotDotLink("","", "", "", "");

  hasChild = (_: number, node: HotspotDotLink) => !!node.children && node.children.length > 0;

  addDot() {
    if(this.dotFormGroup.valid) {
      let hotspotDotLabel = this.dotFormGroup.get('dotLabel').value;
      let hotspotDotLinkRef = this.dotFormGroup.get('dotLinkRef').value.id;
      this.dialogRef.close({
        dotLabel: hotspotDotLabel,
        linkRef: hotspotDotLinkRef,
        linkBaseId: this.selectedLink.baseId,
        linkTarget: this.selectedLink.link
      });
    }
  }

  static copy(o) {
    return Object.assign({}, o)
  }

  filter(search) {

    let filteredTreeData: HotspotDotLink[];
    if (search) {

      filteredTreeData = this.treeData.map(element => ChangeLinkByTocTreeComponent.copy(element)).filter(function f(o) {

        if (o.children) {
          return (o.children = o.children.map(element => ChangeLinkByTocTreeComponent.copy(element)).filter(f)).length
        }
        return o.title.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
      });

      this.dataSource.data = filteredTreeData;
      this.treeControl.dataNodes = filteredTreeData;

    } else {
      this.dataSource.data = this.treeData;
      this.treeControl.dataNodes = this.treeData;
    }

    if(search) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }

}

